'use client'
import React, { useState } from 'react'

import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/utilities/ui'
import { i18n } from './i18n'
import { useLocale } from '@/providers/Locale'

interface Props {
    className?: string
    fullWidthCta?: boolean
}

export const NewsletterSignup: React.FC<Props> = ({ className, fullWidthCta }) => {
    const { locale } = useLocale()
    const [email, setEmail] = useState('')
    const [isSubscribed, setIsSubscribed] = useState(false)

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault()

        const formData = new FormData()
        formData.append('email', email)
        formData.append('newsletters', JSON.stringify(['quartz-daily-brief']))

        await fetch('/api/newsletter/subscribe', {
            method: 'POST',
            body: formData,
        })
        setIsSubscribed(true)
    }
    return (
        <div className={className}>
            <h2 className='font-bold text-xl mb-4'>📬 {i18n[locale].signupHeading}</h2>
            <form onSubmit={handleSubmit}>
                <Card className='p-4 flex flex-col gap-4'>
                    <h3>{i18n[locale].signupDescription}</h3>
                    {isSubscribed ? (
                        <p className={cn('text-lg')}>{i18n[locale].successSubtitle}</p>
                    ) : (
                        <>
                            <Input
                                type='email'
                                placeholder={i18n[locale].inputPlaceholder}
                                onChange={(event) => setEmail(event.target.value)}
                                value={email}
                            ></Input>
                            <Button type='submit' className={cn('bg-accent', { 'w-max': !fullWidthCta })}>
                                {i18n[locale].ctaText}
                            </Button>
                        </>
                    )}
                </Card>
            </form>
        </div>
    )
}
